import styled from 'styled-components';
import valentinoLoading from '../../utils/valentinoLoading';

export default styled.div`
  background: url(${valentinoLoading}) center no-repeat;
  width: 100%;
  height: 6.75rem; // about as tall as four rows
`;
